import { theme } from "@chakra-ui/theme";

export const Button = {
  variants: {
    solid: (props: any) => ({
      ...theme.components.Button.variants.solid(props),
      borderRadius: "full",
      colorScheme: "cherryButton",
      fontWeight: 400,
    }),
    "cherry-outline": {
      borderRadius: "full",
      backgroundColor: "white",
      borderWidth: "1px",
      borderColor: "cherryButton.800",
      color: "cherryButton.800",
      fontWeight: 400,
      fontSize: "xs",
      _hover: { backgroundColor: "cherryButton.25" },
      _active: { backgroundColor: "cherryButton.25" },
    },
    "cherry-outline-inverse": {
      borderRadius: "full",
      backgroundColor: "cherryButton.800",
      borderWidth: "1px",
      borderColor: "cherryButton.800",
      color: "white",
      fontWeight: 400,
      fontSize: "xs",
      _hover: { backgroundColor: "cherryButton.500" },
      _active: { backgroundColor: "cherryButton.500" },
    },
  },
};
